import React, { useMemo } from "react";
import { ServiceOptions } from "../../types/serviceDetail";

interface Props {
  serviceOption: ServiceOptions[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceOption: React.FC<Props> = ({
  serviceOption,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const renderTitle = useMemo(() => {
    if (!sectionTitle) return null;
    const TitleTag = isPage ? "h3" : "p"; // Conditional tag name
    return React.createElement(TitleTag, {
      className: "text-center font-16 font-sm-14 text-black ff-semibold mb-3",
      dangerouslySetInnerHTML: { __html: sectionTitle },
    });
  }, [sectionTitle, isPage]);

  const renderLine = useMemo(() => {
    if (!line) return null;
    return <p className="font-12 text-grey ff-normal text-center">{line}</p>;
  }, [line]);

  return (
    <div className="applicable-main-wrap py-4">
      {renderTitle}
      {renderLine}

      <div className="serv-optn">
        {serviceOption.map((options, index) => (
          <div
            key={index}
            className="d-flex align-items-start gap-2 p-3 rounded layout-border applicable-wrap mb-2"
          >
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/bulb.svg"
              alt="Icon"
            />
            <div>
              {React.createElement(
                isPage ? "h3" : "p", // Conditional tag name
                {
                  className: "text-black ff-semibold font-14 font-sm-12 mb-1",
                  dangerouslySetInnerHTML: { __html: options?.title ?? "" },
                }
              )}
              <p className="ff-medium font-12 font-sm-10 text-grey mb-1">
                {options?.description || ""}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceOption;
